<template>
  <div id="app">
    <div class="cont">
      <div class="nav">
        <navigation-bar/>
      </div>
      <transition name="alert-slide">
        <div class="alert" v-if="alertMessage">
          <p class="message">{{ alertMessage }}</p>
          <p class="close-button" @click="onAlertCloseButtonClick">&times;</p>
        </div>
      </transition>
      <section class="main">
        <template v-if="isLoggedIn && isFetching">
          <panel class="content fetch-panel">
            <loading-wheel class="lw" size="3em"/>
            <p>{{ $t('app.fetchingServerConstants') }}</p>
          </panel>
        </template>
        <template v-if="isLoggedIn && isError">
          <panel class="content fetch-panel">
            <p>{{ $t('app.fetchServerConstantsError') }}</p>
          </panel>
        </template>
        <template v-if="!isLoggedIn || isFetched"><router-view class="content"/></template>
      </section>
    </div>

    <footer class="footer">
      <ul class="link-list">
        <li class="link-list-item"><a href="/terms.html" target="_blanc">{{ $t('app.terms') }}</a></li>
      </ul>
    </footer>
  </div>
</template>

<style lang="scss">
html, body {
  min-height: 100vh;
  font-family: 'Helvetica Neue', 'Arial', 'Hiragino Kaku Gothic Pro', 'YuGothic', 'Yu Gothic', 'Meiryo UI', 'Meiryo', 'MS PGothic', sans-serif;
  background-color: #eeeeee;
}
</style>

<style lang="scss" scoped>
.alert {
  z-index: 2;
  position: fixed;
  top: 45px;
  right: 0;
  left: 0;
  background-color: #ffff80;
  text-align: center;
  box-shadow: 0 1px 10px -5px #000;
  margin: 0 20px;
  display: flex;
  align-items: center;

  .message {
    flex-grow: 1;
  }
  .close-button {
    flex-basis: 1em;
    margin: 1em;
    cursor: pointer;
  }
}
.alert-slide-enter-active, .alert-slide-leave-active {
  transition: opacity .3s, transform .3s;
}
.alert-slide-enter, .alert-slide-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.nav {
  z-index: 3;
  background-color: #fff;
  height: 44px;
  border-bottom: 1px #00dd00 solid;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
}
.main {
  z-index: 1;
  padding-top: 45px;
  margin-left: 20px;
  margin-right: 20px;
}

.fetch-panel {
  margin-top: 1em;
  display: flex;
  align-items: center;

  .lw {
    margin-right: 1em;
  }
}

.footer {
  text-align: center;

  .link-list {
    list-style-type: none;
    padding: 0;

    .link-list-item {
      color: #555;
      font-size: 0.7em;

      a {
        color: #333;
        text-decoration: none;
        border-bottom: #333 1px dotted;
        &:hover, &:target, &:visited {
          color: inherit;
          text-decoration: inherit;
        }
      }
    }
  }
}
</style>

<script>
import 'normalize.css'

import { mapActions, mapGetters, mapState } from 'vuex'

import Consts from './lib/Consts'

import NavigationBar from './components/NavigationBar.vue'
import LoadingWheel from './components/LoadingWheel.vue'
import Panel from './components/Panel.vue'

export default {
  name: 'App',
  components: {
    NavigationBar,
    LoadingWheel,
    Panel
  },
  computed: {
    ...mapState(['alertMessage']),
    ...mapState('serverConstants', ['isFetched', 'isFetching', 'isError']),
    ...mapGetters('session', ['isLoggedIn'])
  },
  async mounted () {
    if (this.isLoggedIn) {
      await this.fetchServerConstants()
    }
    const flashMessage = localStorage.getItem(Consts.LS_KEY_FLASH_MESSAGE)
    if (flashMessage) {
      this.displayAlert({ message: flashMessage })
      localStorage.removeItem(Consts.LS_KEY_FLASH_MESSAGE)
    }
  },
  methods: {
    ...mapActions(['displayAlert', 'closeAlert']),
    ...mapActions('serverConstants', { fetchServerConstants: 'fetch' }),
    onAlertCloseButtonClick () {
      this.closeAlert()
    }
  }
}
</script>
